// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.desktop-menu-accordion[data-v-f3729364] {\n  width: 100%;\n  /*white-space: nowrap;*/\n  background-color: #6c828c;\n}\n\n", ""]);
// Exports
module.exports = exports;
